/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-06-04",
    versionChannel: "nightly",
    buildDate: "2023-06-04T00:19:21.198Z",
    commitHash: "f62d80dd93c4d7e4ebec5a15b93eb92e89f10fae",
};
